const STORAGE_KEY = 'app_build_id'
const CHECK_INTERVAL_MS = 5 * 60 * 1000

async function fetchBuildVersion() {
  const response = await fetch(`/version.json?t=${Date.now()}`, {
    cache: 'no-store',
  })

  if (!response.ok) {
    return null
  }

  const payload = await response.json()
  return payload && payload.version ? String(payload.version) : null
}

async function checkAppVersion() {
  if (process.env.NODE_ENV !== 'production') {
    return
  }

  try {
    const version = await fetchBuildVersion()
    if (!version) {
      return
    }

    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored && stored !== version) {
      localStorage.setItem(STORAGE_KEY, version)
      window.location.reload()
      return
    }

    if (!stored) {
      localStorage.setItem(STORAGE_KEY, version)
    }
  } catch (error) {
    // Ignore version check failures so the app keeps working offline/CDN blips.
  }
}

export default function startAppVersionWatcher() {
  checkAppVersion()

  window.setInterval(checkAppVersion, CHECK_INTERVAL_MS)
  window.addEventListener('focus', checkAppVersion)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      checkAppVersion()
    }
  })
}
